import { createAction } from '@reduxjs/toolkit'

/** Remember the destination before initialization, independently of the popup lifetime. */
export const tableUploadRegistered = createAction<{ matterId: string; tableId: string; clientTmpId: string }>('tableAnalysis/uploadRegistered')
